<template>

  <b-container>
    <div class="justify-content-center p-0 w-100 text-center">

      <b-button class="q-link border-0 m-1 p-1"
                @click="changeItemQuantity(item.quantity, 'up')">+
      </b-button>
      <span class="m-1 px-2 py-2 q-link bg-light rounded text-dark">{{ item.quantity }}</span>

      <b-button class="q-link border-0 m-1 p-1"
                @click="changeItemQuantity(item.quantity, 'down')"
                :disabled="item.quantity==1">-
      </b-button>

      <b-button class="rounded p-0 mb-1" variant="transparent" @click="deleteItem()">
        <b-icon variant="danger" icon="cart-x-fill"/>
      </b-button>

    </div>
  </b-container>

</template>

<script>
export default {
  name: "ShoppingCartQuantityManager",
  props: {
    item: {
      default: {}
    },
    order: {
      default: {}
    }
  },
  methods: {
    changeItemQuantity(quantity, mode = 'up') {
      const form = {
        order_product_id: this.item.id,
        quantity: mode === 'up' ? quantity + 1 : quantity - 1,
        order_id: this.order.id,
        user_id: this.order.user.id,
      };
      console.log(form)
      this.$store.dispatch("ShoppingCart/changeQuantityWithoutState", form)
          .then(res => {
            let response = res.data.data;
            this.$store.commit("ShoppingCart/setSidebarBasketData", response);
            this.$store.commit("ShoppingCart/setUserOrderUnpaidItems", response.items);
          })
          .catch(error => {

            this.$store.dispatch("ShoppingCart/userOrderUnpaid")


          })
      this.$forceUpdate()
    },
    deleteItem() {
      this.$store.dispatch("ShoppingCart/removeItem", {
        order_product_id: this.item.id,
        order_id: this.order.id
      })
    },
  },
}
</script>

<style scoped>

</style>